import React, { useEffect, useState } from 'react'
import { navigate } from 'gatsby'
import axios from 'axios'

import Seo from '../components/Seo/Seo'
import Layout from '../components/Layout/Layout'

import styled from 'styled-components'
import pxToRem from '../utils/pxToRem'
import Button from '../components/Button/Button'
import Hero from '../components/Hero/Hero'
import RoutingEnum from '../routes/appRoutes'
import ButtonVariantEnum from '../enums/ButtonVariant'
import SearchBarSmall from '../components/SearchBarSmall/SearchBarSmall'
import { suggest } from '../routes/apiRoutes'
import { API_APP_KEY } from '../config/ApiConfig'

const SORRY_JOB_NOT_FOUND = 'Sorry, this position has been filled'
const TEXT_JOB_NOT_FOUND = 'We encourage you to explore other opportunities with us. Thank you for considering Constellium as your potential workplace!'
const JOBS_OFFERS_PAGE = 'Job Offers'
const PAGE_NOT_FOUND = 'Page Not Found'
const SORRY_PAGE_NOT_FOUND = 'Sorry, Page Not Found'
const TEXT_NOT_FOUND = 'The page you requested could not be found'
const ERROR = '404'
const HOME_PAGE = 'Home Page'
const CONTACT_US = 'Contact us'

const StyledError = styled.p`
  margin: 0 auto ${pxToRem(-90)} auto;
  line-height: ${pxToRem(234)};
  font-size: ${pxToRem(200)};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
`

const StyledBody = styled.div`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  display: flex;
  margin: 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.unique.white};
  width: 100%;
  padding: 0 0 ${pxToRem(40)};
  background-color: ${({ theme }) => theme.colors.unique.black};
`

const StyledBlockContent = styled.div`
  align-items: center;
  justify-content: center;
  flex-direction: column;
  display: flex;
  margin: 0;
  border-radius: ${pxToRem(5)};
  width: 100%;
  max-width: ${pxToRem(800)};
  padding: 0;
  background-color: ${({ theme }) => theme.colors.unique.white};
`

const StyledBlockContentJob = styled.div`
  align-items: center;
  justify-content: center;
  flex-direction: column;
  display: flex;
  margin: 0 auto;
  border-radius: ${pxToRem(5)};
  width: 100%;
  max-width: ${pxToRem(800)};
  padding: 0;
  background-color: ${({ theme }) => theme.colors.unique.white};
`

const StyledTitle = styled.h2`
  padding: ${pxToRem(20)} 0;
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  font-size: ${({ theme }) => theme.fonts.sizes.titleH2};
  line-height: ${({ theme }) => theme.fonts.lineHeight.titleH2};
  text-align: center;
`
const StyledLine = styled.div`
  width: ${pxToRem(100)};
  height: ${pxToRem(2)};
  border-radius: ${pxToRem(10)};
  background-color: ${({ theme }) => theme.colors.primary.blue};
`

const StyledText = styled.p`
  text-align: center;
  padding: ${pxToRem(20)};
`

const StyledBlockCTA = styled.div`
  align-items: center;
  display: flex;
  margin: ${pxToRem(20)};
`

const StyledButton = styled(Button)`
  margin: ${pxToRem(10)};
`

const NotFoundPage = ({ location }) => {
  const [suggestions, setSuggestions] = useState([])
  const [keywords, setKeywords] = useState('')
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
    return () => setIsMounted(false)
  }, [])

  const handleNewSearch = () => {
    if (keywords) navigate(`${RoutingEnum.search}#q=${keywords}`)
  }
  const handleAutocompletion = async (newKeywords) => {
    if (!newKeywords) return setSuggestions([])
    try {
      const result = await axios.get(`${suggest}/all?code=${API_APP_KEY}`, {
        headers: {
          'Cache-Control': 'no-cache',
        },
        params: { q: newKeywords },
      })
      setSuggestions(result?.data)
    } catch (error) {
      console.error(error)
    }
  }



  if(isMounted && location.pathname.includes(RoutingEnum.jobSearchWithTrailing)) {
    return (<Layout>
      <Seo title='Job: Page Not found' canonicalHref={RoutingEnum.jobNotFound} />
      <Hero
        title={PAGE_NOT_FOUND}
        pathname={RoutingEnum.jobNotFound}
        slug={RoutingEnum.jobNotFound}
        isBreadcrumbsHidden={true}
      />
      <StyledBlockContentJob>
        <StyledTitle>{SORRY_JOB_NOT_FOUND}</StyledTitle>
        <StyledLine />
        <StyledText>{TEXT_JOB_NOT_FOUND}</StyledText>
        <StyledBlockCTA>
          <StyledButton
            to={RoutingEnum.jobSearch}
            variant={ButtonVariantEnum.primary}
          >
            {JOBS_OFFERS_PAGE}
          </StyledButton>
          <StyledButton
            to={RoutingEnum.contact}
            variant={ButtonVariantEnum.secondary}
          >
            {CONTACT_US}
          </StyledButton>
        </StyledBlockCTA>
      </StyledBlockContentJob>
    </Layout>)
  } else {
    return (
      isMounted
        ? (<Layout>
          <Seo title='404: Not found' canonicalHref={RoutingEnum.notFound} />
          <Hero
            title={PAGE_NOT_FOUND}
            pathname={RoutingEnum.notFound}
            slug={RoutingEnum.notFound}
          />
          <StyledError>{ERROR}</StyledError>
          <StyledBody>
            <SearchBarSmall
              handleAutocompletion={handleAutocompletion}
              handleNewSearch={handleNewSearch}
              keywords={keywords}
              setKeywords={setKeywords}
              suggestions={suggestions}
            />
            <StyledBlockContent>
              <StyledTitle>{SORRY_PAGE_NOT_FOUND}</StyledTitle>
              <StyledLine />
              <StyledText>{TEXT_NOT_FOUND}</StyledText>
              <StyledBlockCTA>
                <StyledButton
                  to={RoutingEnum.home}
                  variant={ButtonVariantEnum.primary}
                >
                  {HOME_PAGE}
                </StyledButton>
                <StyledButton
                  to={RoutingEnum.contact}
                  variant={ButtonVariantEnum.secondary}
                >
                  {CONTACT_US}
                </StyledButton>
              </StyledBlockCTA>
            </StyledBlockContent>
          </StyledBody>
        </Layout>) : null
    )
  }
}

export default NotFoundPage
